import React, { useState } from "react";
import { ComponentProps, StaffMember } from "../../../types";
import { SectionWrapper } from "../../containers/SectionWrapper";
import * as styles from "./StaffDirectory.module.css";
import { StaffMember as StaffMemberComponent } from "./StaffMember";
import Modal from "react-modal";
import CloseButton from "../../elements/CloseButton/CloseButton";

interface Props extends ComponentProps {
  staffMembers: StaffMember[];
  subhead: string;
  showImages?: boolean;
}

export const StaffDirectory: React.FC<Props> = ({
  staffMembers,
  subhead,
  showImages,
  ...props
}) => {
  if (typeof document === "undefined") return null;

  const [contactModalOpen, setContactModalOpen] = useState(false);
  const [contactForm, setContactForm] = useState(<></>);

  const renderStaffMembers = () => {
    return staffMembers.map((member, idx) => {
      return (
        <StaffMemberComponent
          member={member}
          key={`staffMemberDirectory-${idx}`}
          showImage={showImages}
          setContactModalOpen={setContactModalOpen}
          setContactForm={setContactForm}
        />
      );
    });
  };

  return (
    <SectionWrapper {...props}>
      <Modal
        isOpen={contactModalOpen}
        preventScroll={true}
        appElement={document?.body}
        shouldCloseOnEsc={true}
        onRequestClose={() => setContactModalOpen(false)}
        style={{
          overlay: {
            zIndex: 1000,
          },
          content: {
            border: "none",
            borderRadius: 0,
            padding: "2rem",
          },
        }}
      >
        <div className={styles.modalCloseButton}>
          <CloseButton
            visualStyle="dark"
            onClick={() => setContactModalOpen(false)}
            size={24}
          />
        </div>
        {contactForm}
      </Modal>
      <div className={styles.staffdirectory}>
        <div className={styles.content}>
          <h2 data-kontent-element-codename="subhead">{subhead}</h2>
          <div
            data-kontent-element-codename="staff_members"
            className={styles.staffGrid}
          >
            {renderStaffMembers()}
          </div>
        </div>
      </div>
    </SectionWrapper>
  );
};
